import React from 'react';
import Button from '../Button';

import './styles.scss';

const ColumnSection = () => {
  return (
    <div className="column-section__wrapper">
      <section className="column-section">
        <div className="column-section__left">
          <div>
            <div className="column-section__content">
              <p><strong>CustomArt</strong> zrodziła się na scenie w świetle reflektorów, a motorem napędowym do jej powstania była aktualnie flagowa formacja TheCustoms.
              Na przestrzeni lat nawiązaliśmy współpracę z <strong>ciekawymi artystami</strong> oraz rozwinęliśmy ofertę o szereg usług dodatkowych dedykowanych dla branży eventowej. 
              <strong> Nasze portfolio</strong> to zarówno proste wydarzenia, skupione na zabawie przy dźwiękach dobrej muzyki, jak i nietypowe zlecenia – występy na wysokich konstrukcjach, synchronizowanie dźwięku z efektami pirotechnicznymi i mappingami, czy kompleksowe tworzenie <strong>autorskiej oprawy artystycznej</strong>.</p>
              <p>Dzięki rosnącemu zaufaniu klientów stale rozwijaną i kluczową pozycją w oferowanych usługach są właśnie <strong>rozwiązania customowe</strong>, czyli tworzone pod konkretne wydarzenie.
                Droga, którą przeszliśmy jest <strong>wyjątkowa</strong> i wierzymy, że nie mogła zaprowadzić nas gdzie indziej, dlatego staramy się dbać o każdy detal naszych realizacji, osiągniętą pozycję i stale się rozwijać.
                Dzięki pasji, miłości do muzyki i sztuki oraz pozytywnemu nastawieniu spełniamy coraz odważniejsze <strong>wizje klientów</strong> i zdobywamy ich zaufanie.
              Aktualnie agencja oferuje szeroki wachlarz produktów artystycznych, pełną technikę estradową oraz <strong>rozwiązania szyte na miare</strong> od kreacji artystycznej po realizację stworzonego show.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
};

export default ColumnSection;



// WEBPACK FOOTER //
// ./src/components/ColumnSection/index.js